import type { Plugins } from 'core/plugins/config/types';

/**
 * Split plugins into arrays by hook type.
 */
export function splitPluginsByHookType(plugins: Plugins.Model[]): {
  beforeRender: Plugins.Model[];
  afterRender: Plugins.Model[];
} {
  return plugins.reduce(
    (acc, cur) => {
      if (cur.afterRender) {
        acc.afterRender.push(cur);
      } else {
        acc.beforeRender.push(cur);
      }
      return acc;
    },
    {
      beforeRender: <Plugins.Model[]>[],
      afterRender: <Plugins.Model[]>[],
    },
  );
}
